<template>
  <div class="WARNING-CONTENT d-flex fd-column flex-center">
    <div class="WARNING-ICON">
      <img v-if="warningIcon" :src="warningIcon">
    </div>
    <div class="WARNING-TITLE" selenium="warning-title">
      {{ warning.extra_info.header }}
    </div>
    <div class="WARNING-MESSAGE" selenium="warning-message">
      <span class="d-none:t">{{ warning.extra_info.short_text }}</span>
      <span class="d-none:mo">{{ warning.message }}</span>
    </div>
    <div class="WARNING-CTA">
      <a
          class="WARNING-CTA-BUTTON"
          selenium="warning-button"
          @click="$emit('cta-clicked', warning)">
        <span class="d-none:t">{{ warning.extra_info.short_cta }}</span>
        <span class="d-none:mo">{{ warning.extra_info.full_cta }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import WARNINGS_METADATA, { DEFAULT_WARNING_ICON } from '@/constants/warnings';

export default {
  name: 'warning-content',
  props: {
    warning: {
      type: Object,
      required: true,
    },
  },
  computed: {
    warningIcon () {
      const warning = WARNINGS_METADATA[this.warning.code];
      return warning ? warning.icon : DEFAULT_WARNING_ICON;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.WARNING-CONTENT {
  @include padding(3);
  width: 100%;
  background-color: $color-green;
  color: white;

  @include tablet {
    background-color: white;
    color: inherit;
  }
}

.WARNING-ICON {
  @include margin(7 0 4 0);
}

.WARNING-TITLE {
  @include h5;
  @include margin-bottom(1);
  font-weight: bold;
}

.WARNING-MESSAGE {
  @include margin-bottom(auto, 6);
}

.WARNING-CTA {
  @include margin(auto 0 6 0, 0 0 6 0);
  width: 100%
}

.WARNING-CTA-BUTTON {
  @include button-ghostfilled();
  @include button-medium();
  width: 100%;

  @include tablet {
    @include button-primary();
    width: auto;
  }
}
</style>
